import "./print.css";

const ACTION_PRINT_TRIGGER = '.js-action--printTrigger';

const printService = {
    print: function (target) {
        if (!target) {
            return;
        }

        let printTarget;

        if (target.constructor === String) {
            printTarget = document.getElementById(target)
        } else if (typeof target === 'object' && 'outerHTML' in target) {
            printTarget = target;
        }

        if (!printTarget) {
            return;
        }

        const printContainer  = document.createElement('div'); // maybe move to an iframe
        printContainer.innerHTML = printTarget.outerHTML;
        printContainer.classList.add('printArea');
        document.body.appendChild(printContainer);
        window.addEventListener('afterprint', () => { printContainer.remove(); });
        window.print();
    }
};

document.addEventListener('click', e => {
    if (!e.target.matches(ACTION_PRINT_TRIGGER)) {
        return;
    }

    e.preventDefault();
    printService.print(e.target.dataset.printTargetId);
});
export default printService;